export default "__VITE_ASSET__D7yQGf0Q__"